import { render, staticRenderFns } from "./CountriesStatistics.vue?vue&type=template&id=21cc80b8&scoped=true&"
import script from "./CountriesStatistics.vue?vue&type=script&lang=js&"
export * from "./CountriesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CountriesStatistics.vue?vue&type=style&index=0&id=21cc80b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc80b8",
  null
  
)

export default component.exports